import $axios from '../api.js';

const state = () => ({
    qris_summary: {
        qris_balance: 0.0,
    },
    qris_providers: [],
    qris_merchants: [],
    qris_merchant_data: {
        qris_provider_id: '',
    },
    qris_payments_summary: {
        count_of_trx: 0,
        sum_of_trx: 0,
    },
    qris_payments: {
        data: [],
        current_page: 1,
    },
    qris_payments_detail: {
        id: '',
        customer_id: '',
        qris_merchant_id: '',
        qris_settlement_id: '',
        qris_merchant: {
            merchant_id: '',
            merchant_name: '',
        },
        qris_settlement: {
            settlement_type: '',
            settlement_date: '',
            settled_at: '',
            status: '',
        },
        amount: 0.0,
        fee: 0.0,
        fee_fast_settlement: 0.0,
        amount_disbursed: 0.0,
        reference_data: {
            issuer: '',
            rrn: '',
        },
        paid_at: '',
        settled_at: '',
        status: '',
    },
    qris_payments_meta: {
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
    },
    qris_settlements: {
        data: [],
        current_page: 1,
    },
    qris_settlement_data: {
        id: '',
        qris_merchant: {
            merchant_id: '',
            merchant_name: '',
        },
        settlement_type: '',
        settlement_date: '',
        settled_at: '',
        total_amount: 0.0,
        total_fee: 0.0,
        total_fee_fast_settlement: 0.0,
        total_amount_disbursed: 0.0,
        status: '',
    },
    qris_settiement_summary: {
        sum_of_settlement_waiting: 0,
        sum_of_settlement_completed: 0,
    },
    qris_settlement_meta: {
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
    },

    loading: {
        button: false,
        screen: false,
        pagination: false,
    },
});

const mutations = {
    SET_QRIS_SUMMARY(state, payload) {
        state.qris_summary = {
            qris_balance: payload.qris_balance,
        };
    },
    SET_QRIS_PROVIDER(state, payload) {
        state.qris_providers = payload;
    },
    SET_QRIS_MERCHANT(state, payload) {
        state.qris_merchants = payload;
    },
    SET_QRIS_MERCHANT_DATA(state, payload) {
        state.qris_merchant_data = payload;
    },

    SET_QRIS_PAYMENT_SUMMARY(state, payload) {
        state.qris_payments_summary = payload;
    },

    SET_QRIS_PAYMENT(state, payload) {
        state.qris_payments.data.push(...payload.data);
        state.qris_payments.to = payload.to;
        state.qris_payments.per_page = payload.per_page;
        state.qris_payments.next_page_url = payload.next_page_url;
    },
    SET_QRIS_PAYMENT_DETAIL(state, payload) {
        state.qris_payments_detail = {
            id: payload.id,
            customer_id: payload.customer_id,
            qris_merchant_id: payload.qris_merchant_id,
            qris_settlement_id: payload.qris_settlement_id,
            qris_merchant: {
                merchant_id: payload.qris_merchant.merchant_id,
                merchant_name: payload.qris_merchant.merchant_name,
            },
            qris_settlement: {
                settlement_type: payload.qris_settlement.settlement_type,
                settlement_date: payload.qris_settlement.settlement_date,
                settled_at: payload.qris_settlement.settled_at,
                status: payload.qris_settlement.status,
            },
            amount: payload.amount,
            fee: payload.fee,
            fee_fast_settlement: payload.fee_fast_settlement,
            amount_disbursed: payload.amount_disbursed,
            reference_data: {
                issuer: JSON.parse(payload.reference_data).issuer,
                rrn: JSON.parse(payload.reference_data).rrn,
            },
            paid_at: payload.paid_at,
            settled_at: payload.settled_at,
            status: payload.status,
        };
    },
    SET_QRIS_SETTLEMENT(state, payload) {
        state.qris_settlements.data.push(...payload.data);
        state.qris_settlements.to = payload.to;
        state.qris_settlements.per_page = payload.per_page;
        state.qris_settlements.next_page_url = payload.next_page_url;
    },
    SET_QRIS_SETTLEMENT_DETAIL(state, payload) {
        state.qris_settlement_detail = {
            id: payload.id,
            qris_merchant: {
                merchant_id: payload.qris_merchant.merchant_id,
                merchant_name: payload.qris_merchant.merchant_name,
            },
            settlement_type: payload.settlement_type,
            settlement_date: payload.settlement_date,
            settled_at: payload.settled_at,
            total_amount: payload.total_amount,
            total_fee: payload.total_fee,
            total_fee_fast_settlement: payload.total_fee_fast_settlement,
            total_amount_disbursed: payload.total_amount_disbursed,
            status: payload.status,
        };
    },
    SET_QRIS_SETTLEMENT_SUMMARY(state, payload) {
        state.qris_settlement_summary = payload;
    },

    RESET_QRIS_MERCHANT_DATA(state) {
        state.qris_merchant_data = {
            qris_provider_id: '',
        };
    },
    RESET_QRIS_PAYMENT_SUMMARY(state) {
        state.qris_payments_summary = {
            count_of_trx: 0,
            sum_of_trx: 0,
        };
    },
    RESET_QRIS_PAYMENT(state) {
        state.qris_payments = {
            data: [],
            current_page: 1,
        };
    },
    RESET_QRIS_PAYMENT_META(state) {
        state.qris_payments_meta = {
            startDate: new Date().toISOString(),
            endDate: new Date().toISOString(),
        };
    },
    RESET_QRIS_PAYMENT_DETAIL(state) {
        state.qris_payments_detail = {
            id: '',
            customer_id: '',
            qris_merchant_id: '',
            qris_settlement_id: '',
            qris_merchant: {
                merchant_id: '',
                merchant_name: '',
            },
            qris_settlement: {
                settlement_type: '',
                settlement_date: '',
                settled_at: '',
                status: '',
            },
            amount: 0.0,
            fee: 0.0,
            fee_fast_settlement: 0.0,
            amount_disbursed: 0.0,
            reference_data: {
                issuer: '',
                rrn: '',
            },
            paid_at: '',
            settled_at: '',
            status: '',
        };
    },
    RESET_QRIS_SETTLEMENT(state) {
        state.qris_settlements = {
            data: [],
            current_page: 1,
        };
    },
    RESET_QRIS_SETTLEMENT_DETAIL(state) {
        state.qris_settlement_detail = {
            id: '',
            qris_merchant: {
                merchant_id: '',
                merchant_name: '',
            },
            settlement_type: '',
            settlement_date: '',
            settled_at: '',
            total_amount: 0.0,
            total_fee: 0.0,
            total_fee_fast_settlement: 0.0,
            total_amount_disbursed: 0.0,
            status: '',
        };
    },
    RESET_LOADING(state) {
        state.loading = {
            button: false,
            screen: false,
            pagination: false,
        };
    },
    RESET_TOAST(state) {
        state.toast = {
            show: false,
            message: 'Success',
            tipe: 'default',
            top: '',
            position: 'top',
        };
    },
};

const actions = {
    getQrisProvider({ commit }) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/qris/getQrisProvider')
                .then(response => {
                    commit('SET_QRIS_PROVIDER', response.data.responseData);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getQrisMerchantDefault({ commit }) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/qris/getQrisMerchantDefault')
                .then(response => {
                    commit(
                        'SET_QRIS_MERCHANT_DATA',
                        response.data.responseData
                    );
                    commit('SET_QRIS_SUMMARY', response.data.responseSummary);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getQrisMerchant({ commit }) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/qris/getQrisMerchant')
                .then(response => {
                    commit('SET_QRIS_MERCHANT', response.data.responseData);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getQrisMerchantDetail({ commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/qris/getQrisMerchant/' + payload)
                .then(response => {
                    commit(
                        'SET_QRIS_MERCHANT_DATA',
                        response.data.responseData
                    );
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    storeQrisMerchant({ state }) {
        return new Promise((resolve, reject) => {
            $axios
                .post('/qris/storeQrisMerchant', state.qris_merchant_data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    updateToggleFastSettlement({ state, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            $axios
                .patch(
                    '/qris/updateToggleFastSettlement/' + payload,
                    state.qris_merchant_data
                )
                .then(() => {
                    dispatch('getQrisMerchantDetail', payload).then(response =>
                        resolve(response.data)
                    );
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    updateToggleDefault({ state, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            $axios
                .patch(
                    '/qris/updateToggleDefault/' + payload,
                    state.qris_merchant_data
                )
                .then(response => {
                    dispatch('getQrisMerchantDetail', payload).then(response =>
                        resolve(response.data)
                    );
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getQrisPaymentSummary({ state, commit }, payload) {
        state.loading.pagination = true;
        return new Promise((resolve, reject) => {
            $axios
                .get(payload ? payload : '/qris/getQrisPaymentSummary', {
                    params: state.qris_payments_meta,
                })
                .then(response => {
                    commit(
                        'SET_QRIS_PAYMENT_SUMMARY',
                        response.data.responseData
                    );
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getQrisPayment({ state, commit }, payload) {
        state.loading.pagination = true;
        return new Promise((resolve, reject) => {
            $axios
                .get(payload ? payload : '/qris/getQrisPayment', {
                    params: state.qris_payments_meta,
                })
                .then(response => {
                    state.loading.pagination = false;
                    commit('SET_QRIS_PAYMENT', response.data.responseData);
                    resolve(response.data);
                })
                .catch(error => {
                    state.loading.pagination = false;
                    reject(error.response);
                });
        });
    },
    getQrisPaymentDetail({ commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/qris/getQrisPayment/' + payload)
                .then(response => {
                    commit(
                        'SET_QRIS_PAYMENT_DETAIL',
                        response.data.responseData
                    );
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getQrisSettlementSummary({ state, commit }, payload) {
        state.loading.pagination = true;
        return new Promise((resolve, reject) => {
            $axios
                .get(payload ? payload : '/qris/getQrisSettlementSummary', {
                    params: state.qris_settlement_meta,
                })
                .then(response => {
                    commit(
                        'SET_QRIS_SETTLEMENT_SUMMARY',
                        response.data.responseData
                    );
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getQrisSettlement({ state, commit }, payload) {
        state.loading.pagination = true;
        return new Promise((resolve, reject) => {
            $axios
                .get(payload ? payload : '/qris/getQrisSettlement')
                .then(response => {
                    state.loading.pagination = false;
                    commit('SET_QRIS_SETTLEMENT', response.data.responseData);
                    resolve(response.data);
                })
                .catch(error => {
                    state.loading.pagination = false;
                    reject(error.response);
                });
        });
    },
    getQrisSettlementDetail({ commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/qris/getQrisSettlement/' + payload)
                .then(response => {
                    commit(
                        'SET_QRIS_SETTLEMENT_DETAIL',
                        response.data.responseData
                    );
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
